import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import axiosInstance from '../../utils/axiosInstance';
import FlashMessage from '../../utils/FlashMessage';
import { AuthContext } from '../../context/AuthContext';
import { HiUserAdd } from 'react-icons/hi'; // An icon for the header

const Register = () => {
  const { login } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');
  const navigate = useNavigate(); // Hook for navigation

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // The register endpoint likely doesn't return a token, it just creates a user.
      // The user should then be redirected to the login page.
      await axiosInstance.post('/users/register', { username, email, password });
      
      // On successful registration, show a message and redirect to login
      setMessage('Registration successful! Please log in.');
      setType('success');
      setTimeout(() => {
        navigate('/login');
      }, 2000); // Redirect after 2 seconds

    } catch (error) {
      setMessage(error.response?.data?.message || 'Registration failed. Please try again.');
      setType('error');
      console.error('Registration failed:', error.response?.data?.message);
    }
  };

  const clearMessage = () => {
    setMessage('');
  };

  return (
    // Main container to center the form
    <div className="min-h-screen  flex flex-col justify-center items-center p-4">
      {message && <FlashMessage message={message} type={type} onClose={clearMessage} />}
      
      {/* The Form Card */}
      <div className="w-full max-w-md bg-gray-300 rounded-xl shadow-lg p-8 space-y-6">
        <div className="text-center">
          <HiUserAdd className="mx-auto h-12 w-12 text-indigo-600" />
          <h2 className="mt-4 text-3xl font-extrabold text-gray-900">
            Create an Account
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="text-sm font-medium text-gray-700">Username</label>
            <input
              type="text"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Password</label>
            <input
              type="password"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button 
            type="submit" 
            className="w-full bg-indigo-600 text-white px-4 py-3 rounded-lg font-semibold text-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-300"
          >
            Register
          </button>
        </form>

        <p className="text-center text-sm text-gray-600">
          Already have an account?{' '}
          <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500">
            Log in here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;